export * from './MenuHeaderBgImage.ui';
